import tw, { styled } from 'twin.macro';

const Header = styled.h4`
  ${tw`leading-5 -mb-8 p-0 text-2xl`};
  color: var(--formBodyLabelColor, var(--formTextColor));
  font-family: var(--formFontType, Circular Std) !important;
  ${({ divider }) => divider && `border-bottom: 1px solid rgba(34,36,38,.15);`}
  ${({ alignment }) => `text-align: ${alignment}`};
  font-weight: 500;
`;

export default Header;
